import VuexPersistence from 'vuex-persist'
import { defineNuxtPlugin, useNuxtApp } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
	const { $store } = useNuxtApp()
	return new VuexPersistence().plugin($store)
})